// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3xr1g","rightAdornment":"Header_rightAdornment__1JdLs"};